"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmittedLead_ConsentCheckboxesEntry = exports.SubmittedLead = exports.SubmittedField_SubValuesEntry = exports.SubmittedField = exports.FieldIdentifier = exports.StandardFieldType = exports.ValidationType = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../google/protobuf/wrappers");
/** The ValidationType determines how a field should be validated. */
var ValidationType;
(function (ValidationType) {
    /** UNKNOWN_VALIDATION_UNSET - An unknown field type */
    ValidationType[ValidationType["UNKNOWN_VALIDATION_UNSET"] = 0] = "UNKNOWN_VALIDATION_UNSET";
    /** PLAIN_TEXT - A field of arbitrary text which we won't bother validating or transforming (with the exception that if the field is required, we will reject an empty string) */
    ValidationType[ValidationType["PLAIN_TEXT"] = 1] = "PLAIN_TEXT";
    /** PHONE - A phone number */
    ValidationType[ValidationType["PHONE"] = 2] = "PHONE";
    /** EMAIL - An email address */
    ValidationType[ValidationType["EMAIL"] = 3] = "EMAIL";
    /** ADDRESS - A street address */
    ValidationType[ValidationType["ADDRESS"] = 4] = "ADDRESS";
    /** DATE - A date */
    ValidationType[ValidationType["DATE"] = 5] = "DATE";
    /** MULTI_SELECT_MULTI_ANSWER - For multi select checkbox type questions */
    ValidationType[ValidationType["MULTI_SELECT_MULTI_ANSWER"] = 6] = "MULTI_SELECT_MULTI_ANSWER";
    /** MULTI_SELECT_SINGLE_ANSWER - For multi select radial button type questions with only 1 answer allowed */
    ValidationType[ValidationType["MULTI_SELECT_SINGLE_ANSWER"] = 7] = "MULTI_SELECT_SINGLE_ANSWER";
    ValidationType[ValidationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ValidationType = exports.ValidationType || (exports.ValidationType = {}));
/**
 * If the field is a standard type (such as First Name / Last Name / Email / Mobile Phone),
 * then we can autofill it with the associated user profile data.
 * This type can also be used to standardize fields for aggregate analysis among multiple advertisers.
 */
var StandardFieldType;
(function (StandardFieldType) {
    /** UNKNOWN_STANDARD_UNSET - The type was invalid or not set. If you know it's a non-standard field, use CUSTOM. */
    StandardFieldType[StandardFieldType["UNKNOWN_STANDARD_UNSET"] = 0] = "UNKNOWN_STANDARD_UNSET";
    /** CUSTOM - Indicates that this is not a standard field, but rather an advertiser-specific custom field */
    StandardFieldType[StandardFieldType["CUSTOM"] = 1] = "CUSTOM";
    /** STANDARD_FIRST_NAME - User's first name */
    StandardFieldType[StandardFieldType["STANDARD_FIRST_NAME"] = 2] = "STANDARD_FIRST_NAME";
    /** STANDARD_LAST_NAME - User's last name */
    StandardFieldType[StandardFieldType["STANDARD_LAST_NAME"] = 3] = "STANDARD_LAST_NAME";
    /** STANDARD_PHONE - User's mobile phone number */
    StandardFieldType[StandardFieldType["STANDARD_PHONE"] = 4] = "STANDARD_PHONE";
    /** STANDARD_EMAIL - User's email */
    StandardFieldType[StandardFieldType["STANDARD_EMAIL"] = 5] = "STANDARD_EMAIL";
    /** STANDARD_ADDRESS - User's mailing address, consisting of Country, Street Address, Apt/Suite/Other, State/Province/Region, City / Town, ZIP/Postal Code */
    StandardFieldType[StandardFieldType["STANDARD_ADDRESS"] = 6] = "STANDARD_ADDRESS";
    /** STANDARD_POSTAL_CODE - Postal code / ZIP code */
    StandardFieldType[StandardFieldType["STANDARD_POSTAL_CODE"] = 7] = "STANDARD_POSTAL_CODE";
    /** STANDARD_BDAY - User's birthday */
    StandardFieldType[StandardFieldType["STANDARD_BDAY"] = 8] = "STANDARD_BDAY";
    /** STANDARD_ORGANIZATION - User's company/organization name */
    StandardFieldType[StandardFieldType["STANDARD_ORGANIZATION"] = 9] = "STANDARD_ORGANIZATION";
    /** STANDARD_ORGANIZATION_TITLE - User's job/organization title */
    StandardFieldType[StandardFieldType["STANDARD_ORGANIZATION_TITLE"] = 10] = "STANDARD_ORGANIZATION_TITLE";
    StandardFieldType[StandardFieldType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(StandardFieldType = exports.StandardFieldType || (exports.StandardFieldType = {}));
function createBaseFieldIdentifier() {
    return { validationType: 0, standardType: 0, customId: undefined };
}
exports.FieldIdentifier = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.validationType !== 0) {
            writer.uint32(8).int32(message.validationType);
        }
        if (message.standardType !== 0) {
            writer.uint32(16).int32(message.standardType);
        }
        if (message.customId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.customId }, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFieldIdentifier();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validationType = reader.int32();
                    break;
                case 2:
                    message.standardType = reader.int32();
                    break;
                case 3:
                    message.customId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseFieldIdentifier();
        message.validationType = object.validationType ?? 0;
        message.standardType = object.standardType ?? 0;
        message.customId = object.customId ?? undefined;
        return message;
    },
};
function createBaseSubmittedField() {
    return { identifier: undefined, value: "", subValues: {} };
}
exports.SubmittedField = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.identifier !== undefined) {
            exports.FieldIdentifier.encode(message.identifier, writer.uint32(10).fork()).ldelim();
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        Object.entries(message.subValues).forEach(([key, value]) => {
            exports.SubmittedField_SubValuesEntry.encode({ key: key, value }, writer.uint32(26).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubmittedField();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.identifier = exports.FieldIdentifier.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                case 3:
                    const entry3 = exports.SubmittedField_SubValuesEntry.decode(reader, reader.uint32());
                    if (entry3.value !== undefined) {
                        message.subValues[entry3.key] = entry3.value;
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSubmittedField();
        message.identifier =
            object.identifier !== undefined && object.identifier !== null
                ? exports.FieldIdentifier.fromPartial(object.identifier)
                : undefined;
        message.value = object.value ?? "";
        message.subValues = Object.entries(object.subValues ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = String(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseSubmittedField_SubValuesEntry() {
    return { key: "", value: "" };
}
exports.SubmittedField_SubValuesEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubmittedField_SubValuesEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSubmittedField_SubValuesEntry();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    },
};
function createBaseSubmittedLead() {
    return { submittedFields: [], consentCheckboxes: {} };
}
exports.SubmittedLead = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.submittedFields) {
            exports.SubmittedField.encode(v, writer.uint32(10).fork()).ldelim();
        }
        Object.entries(message.consentCheckboxes).forEach(([key, value]) => {
            exports.SubmittedLead_ConsentCheckboxesEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubmittedLead();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.submittedFields.push(exports.SubmittedField.decode(reader, reader.uint32()));
                    break;
                case 2:
                    const entry2 = exports.SubmittedLead_ConsentCheckboxesEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.consentCheckboxes[entry2.key] = entry2.value;
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSubmittedLead();
        message.submittedFields =
            object.submittedFields?.map((e) => exports.SubmittedField.fromPartial(e)) || [];
        message.consentCheckboxes = Object.entries(object.consentCheckboxes ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = Boolean(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseSubmittedLead_ConsentCheckboxesEntry() {
    return { key: "", value: false };
}
exports.SubmittedLead_ConsentCheckboxesEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value === true) {
            writer.uint32(16).bool(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubmittedLead_ConsentCheckboxesEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSubmittedLead_ConsentCheckboxesEntry();
        message.key = object.key ?? "";
        message.value = object.value ?? false;
        return message;
    },
};
//# sourceMappingURL=lead_generation_common.js.map